const Home = "Home";
const WindHomeTrends = "WindHomeTrends";
const Login = "Login";
const Profile = "Profile";

const Configurations = "Configurations";
const UserConfigurations = "UserConfigurations";
const CompaniesConfigurations = "CompaniesConfigurations";
const ConstructionParameters = "ConstructionParameters";
const ConstructionParametersSettings = "ConstructionParametersSettings";
const FrequencyTrendConfiguration = "FrequencyTrendConfiguration";

const WindAudio     = "WindAudio";
const WindTrends    = "WindTrends";
const WindRegisters = "WindRegisters";
const WindVDI       = "VDIWind";
const WindOil       = "WindOil";
const PitchAnalysis = "PitchAnalysis";

const HydroAudio     = "HydroAudio";
const HydroEvents    = "HydroEvents";
const HydroTrends    = "HydroTrends";
const HydroRegisters = "HydroRegisters";
const HydroVDI       = "VDIHydro";

const DiagnosticConfigurator = "WindDiagnosticSettings";
const NotificationConfiguration = "NotificationConfigurations";
const AlarmManagement = "AlarmManagement";
const BladeDefect            = "BladeDefect";
const PressureFluctuation    = "PressureFluctuation";
const OilWhirl               = "OilWhirl";
const AngularMisalignment    = "AngularMisalignment";
const ParallelMisalignment   = "ParallelMisalignment";
const Unbalance              = "Unbalance";
const Looseness              = "Looseness";
const BearingPadsDefect      = "BearingPadsDefect";
const StatorDefect           = "StatorDefect";
const OverhungRotor          = "OverhungRotor";
const Rubbing                = "Rubbing";
const MagneticFlux           = "MagneticFlux";
const AirGap                 = "AirGap";

const AnomalyDetection     = "AnomalyDetection";

const WindPark           = "WindPark";
const WindParkTrends     = "WindParkTrends";
const WindGeneratingUnit = "WindGeneratingUnit";
const WindTurbine        = "WindTurbine";

const HydroElectricPowerPlant = "HydroElectricPowerPlant";
const HydroElectricGeneratingUnit = "HydroElectricGeneratingUnit";
const HydroElectricTurbine = "HydroElectricTurbine";

const CompanyTrendLimitsConfiguration = "CompanyTrendLimitsConfiguration";

const WindLimitsSettings = "WindLimitsSettings";
const HydroLimitsSettings = "HydroLimitsSettings";

const FrequencyTrendLimitConfiguration = "FrequencyTrendLimitConfiguration";
const KinematicParametersConfiguration = "KinematicParametersConfiguration";

export default
{
	Home,
	WindHomeTrends,
	Login,
	Profile,
	Configurations,
	UserConfigurations,
	CompaniesConfigurations,
	WindAudio,
	WindTrends,
	HydroAudio,
	HydroEvents,
	HydroTrends,
	WindRegisters,
	HydroRegisters,
	AnomalyDetection,
	PitchAnalysis,
	DiagnosticConfigurator,
	NotificationConfiguration,
	AlarmManagement,
	BladeDefect,
	PressureFluctuation,
	OilWhirl,
	AngularMisalignment,
	ParallelMisalignment,
	Unbalance,
	Looseness,
	BearingPadsDefect,
	StatorDefect,
	OverhungRotor,
	Rubbing,
	MagneticFlux,
	WindPark,
	WindParkTrends,
	WindOil,
	WindGeneratingUnit,
	WindTurbine,
	HydroElectricPowerPlant,
	HydroElectricGeneratingUnit,
	HydroElectricTurbine,
	WindVDI,
	HydroVDI,
	CompanyTrendLimitsConfiguration,
	ConstructionParameters,
	ConstructionParametersSettings,
	FrequencyTrendConfiguration,
	AirGap,
	WindLimitsSettings,
	HydroLimitsSettings,
	FrequencyTrendLimitConfiguration,
	KinematicParametersConfiguration
};